import { render, staticRenderFns } from "./UserExtension.vue?vue&type=template&id=ce1ee7ec&scoped=true&"
import script from "./UserExtension.vue?vue&type=script&lang=js&"
export * from "./UserExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1ee7ec",
  null
  
)

export default component.exports